export default {
	squareAppId: 'sq0idp-rYNeA6_-He6BYcVsrrn8PA'
}
